import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { createCustomPlanPricing } from '../actions/customPlans';
import {
  getSubmitStatus,
  getIncludedInGroups,
  createCustomPlanPricingStatusPending,
} from '../reducers';

import CustomPlanPricingForm from '../components/CustomPlanPricingForm';
import Spinner from '../components/Spinner';
import { formatDateWithoutTimeForAPI } from 'helpers/formatters';

const CreateCustomPlanPricing = ({
  isAdmin,
  saveStatus,
  onSubmit,
  isPendingCreate,
}) => {
  if (!isAdmin) {
    return <Redirect to={'/'} />;
  }

  const handleSubmit = (values) => {
    if (values.effective_start_at) {
      values.effective_start_at = formatDateWithoutTimeForAPI(
        values.effective_start_at,
      );
    }
    return onSubmit(values);
  };

  return (
    <React.Fragment>
      <h1>Create Custom Plan Pricing</h1>
      <br />
      <CustomPlanPricingForm
        onSubmit={handleSubmit}
        saveStatus={saveStatus}
        initialValues={{
          is_visible: false,
        }}
      />
      <Spinner showLoader={isPendingCreate} />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  isAdmin: getIncludedInGroups(state, ['ADMIN']),
  saveStatus: getSubmitStatus(state, 'customPlanPricing'),
  isPendingCreate: createCustomPlanPricingStatusPending(state),
});

const mapDispatchToProps = {
  onSubmit: createCustomPlanPricing,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateCustomPlanPricing);
